/*
 * Copyright (c) 2024-2026, s0up and the autobrr contributors.
 * SPDX-License-Identifier: GPL-2.0-or-later
 */

import React from "react";

/** The Nyrvex mark: an N drawn as one line that ends in a status dot (same artwork as assets/logo-mark.svg). */
export const BrandMark: React.FC<{ size?: number; className?: string }> = ({ size = 28, className }) => (
  <svg width={size} height={size} viewBox="0 0 32 32" className={className ?? "flex-none"} aria-hidden="true">
    <rect width="32" height="32" rx="8" fill="#211e1a" />
    <path d="M9 23V9.5L23 22.5V13" fill="none" stroke="#efe9dd" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
    <circle cx="23" cy="8" r="2.4" fill="#5fa37a" />
  </svg>
);
